import React from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

class ProductModalEngagement extends React.Component{
    
    state = {
        courseStartedTag: this.props.product.courseStartedTag ? this.props.product.courseStartedTag.split(',') : [],
        courseCompleteTag: this.props.product.courseCompleteTag ? this.props.product.courseCompleteTag.split(',') : []
    };

    handleChange = (tags, key) => {
        this.setState({[key]: tags});
        this.props.updateProduct(key, tags.join(','));
    };

    render() {
        return (
            <div className="tab-panel">
                <div className="column">
                    <label>Tags to drop when user starts this product</label>
                    <TagsInput value={this.state.courseStartedTag[0] === "" ? [] : this.state.courseStartedTag} onChange={tags => this.handleChange(tags, 'courseStartedTag')} />
                </div>
                <div className="column">
                    <label>Tags to drop when user completes this product</label>
                    <TagsInput value={this.state.courseCompleteTag[0] === "" ? [] : this.state.courseCompleteTag} onChange={tags => this.handleChange(tags, 'courseCompleteTag')} />
                </div>
            </div>
        );
    }
}

ProductModalEngagement.propTypes = {
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func.isRequired
}

export default ProductModalEngagement;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModalEngagement.js
 **/